import { Component, OnInit } from '@angular/core';
import { NgsRevealConfig } from 'ngx-scrollreveal';

@Component({
  selector: 'app-animations',
  templateUrl: './animations.component.html',
  styleUrls: ['./animations.component.scss'],
  providers: [NgsRevealConfig],
})

export class AnimationsComponent implements OnInit {

  constructor(options: NgsRevealConfig) {
    options.duration = 600;
    options.distance = '100px';
    options.easing = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
    options.origin = 'bottom';
    options.useDelay = 'once';
    options.container = 'window.document.documentElement';
    options.cleanup = true;
  }

  ngOnInit() {

  }

}
